export function FormatApplicant(hit, isPostulation) {
  if (isPostulation) {
    const postulation = hit._source;
    const applicant   = postulation.applicant;
    const pi          = applicant.user.personal_information || {};

    const fullName = [
      pi.first_name,
      pi.middle_name,
      pi.last_name
    ].filter(Boolean).join(" ");

    return {
      value: String(postulation.id),
      label: fullName || applicant.user.email
    };
  }

  const applicant = hit._source;
  const pi        = applicant.user.personal_information || {};
  const fullName  = [
    pi.first_name,
    pi.middle_name,
    pi.last_name
  ].filter(Boolean).join(" ");

  return {
    value: String(applicant.id),
    label: fullName || applicant.user.email
  };
}
